<template>
  <layout>
    <div slot="content">
      <div class="page-title">智能中心</div>

      <el-alert
        type="info"
        :closable="false"
        show-icon
        class="intro-alert"
        title="对话由通义千问根据本地工具返回的数据总结。可问：查某笔订单、最近退款、沟通排行等。需配置 DASHSCOPE_API_KEY。">
      </el-alert>

      <div class="panel-card chat-card">
        <div class="panel-header">智能对话</div>
        <div class="chat-scroll" ref="chatScroll">
          <div
            v-for="(m, idx) in dialog"
            :key="idx"
            :class="['msg-row', m.role === 'user' ? 'msg-row--user' : 'msg-row--bot']">
            <div
              :class="[
                'msg-bubble',
                m.msgKind === 'order' ? 'msg-bubble--order' : '',
                m.msgKind === 'data' ? 'msg-bubble--data' : ''
              ]">
              <div
                v-if="m.role === 'assistant' && m.msgKind === 'order'"
                class="msg-bubble__label msg-bubble__label--order">
                <i class="el-icon-s-order"></i> 订单查询结果
              </div>
              <div
                v-if="m.role === 'assistant' && m.msgKind === 'data'"
                class="msg-bubble__label msg-bubble__label--data">
                <i class="el-icon-s-data"></i> 数据汇总
              </div>
              <div
                class="msg-bubble__body"
                v-html="formatLineBreaks(escapeHtml(m.content))"></div>
            </div>
          </div>
          <div v-if="loading" class="msg-row msg-row--bot">
            <div class="msg-bubble msg-bubble--loading">
              <i class="el-icon-loading"></i> 正在思考并可能查询数据…
            </div>
          </div>
        </div>
        <div class="chat-input-wrap">
          <el-input
            v-model="input"
            type="textarea"
            :rows="2"
            placeholder="例如：最近7天有多少笔退款？查订单 xxx"
            :disabled="loading"
            @keydown.native="onKey">
          </el-input>
          <el-button
            class="send-btn"
            type="primary"
            :loading="loading"
            :disabled="!input.trim()"
            @click="send">发送
          </el-button>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from '@/components/layout'

export default {
  name: 'intelligent-hub',
  components: { layout },
  data() {
    return {
      input: '',
      loading: false,
      dialog: []
    }
  },
  methods: {
    onKey(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault()
        this.send()
      }
    },
    escapeHtml(text) {
      if (!text) return ''
      const s = String(text)
      return s
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
    },
    formatLineBreaks(s) {
      return s.replace(/\n/g, '<br/>')
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.chatScroll
        if (el) {
          el.scrollTop = el.scrollHeight
        }
      })
    },
    send() {
      const text = (this.input || '').trim()
      if (!text || this.loading) {
        return
      }
      this.input = ''
      this.dialog.push({ role: 'user', content: text, msgKind: 'user' })
      this.scrollToBottom()
      this.loading = true
      const payload = { messages: this.dialog.map(function (m) {
        return { role: m.role, content: m.content }
      }) }
      const self = this
      this.$http.request('intelligentChat', payload).then(function (res) {
        self.loading = false
        if (!res || res.status !== 'success' || !res.data) {
          if (res && res.message) {
            self.$message.error(res.message)
          } else {
            self.$message.error('请求失败')
          }
          self.dialog.pop()
          return
        }
        const reply = (res.data.reply != null) ? String(res.data.reply) : ''
        const octx = res.data.order_context
        const rctx = res.data.refund_context
        const cctx = res.data.communicate_context
        let msgKind = 'normal'
        if (octx && typeof octx === 'object') {
          msgKind = 'order'
        } else if ((rctx && typeof rctx === 'object') || (cctx && typeof cctx === 'object')) {
          msgKind = 'data'
        }
        self.dialog.push({
          role: 'assistant',
          content: reply || '（暂无文字说明。）',
          msgKind: msgKind
        })
        self.scrollToBottom()
      }).catch(function () {
        self.loading = false
        self.dialog.pop()
      })
    }
  }
}
</script>

<style scoped>
.page-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
}

.intro-alert {
  margin-bottom: 20px;
}

.panel-card {
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  padding: 16px 20px 20px;
  margin-bottom: 16px;
}

.panel-header {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.chat-card {
  min-height: 560px;
}

.chat-scroll {
  min-height: 520px;
  max-height: min(78vh, 860px);
  overflow-y: auto;
  padding: 12px 8px 16px;
  background: linear-gradient(180deg, #f0f2f5 0%, #e8ecf0 100%);
  border-radius: 8px;
  margin-bottom: 12px;
  border: 1px solid #e4e7ed;
}

.msg-row {
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
}

.msg-row--user {
  justify-content: flex-end;
}

.msg-bubble {
  max-width: 92%;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-word;
  background: #fff;
  border: 1px solid #e4e7ed;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.msg-bubble__body {
  color: #303133;
}

.msg-bubble__label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  margin: -2px 0 10px 0;
  padding-bottom: 8px;
  border-bottom: 1px dashed #dcdfe6;
}

.msg-bubble__label--order {
  color: #1d39c4;
}

.msg-bubble__label--data {
  color: #237804;
}

.msg-bubble--order {
  background: linear-gradient(145deg, #f0f7ff 0%, #e6f4ff 100%);
  border: 1px solid #91caff;
  border-left: 4px solid #2f54eb;
  box-shadow: 0 2px 8px rgba(47, 84, 235, 0.08);
}

.msg-bubble--data {
  background: linear-gradient(145deg, #f6ffed 0%, #f0f9e8 100%);
  border: 1px solid #b7eb8f;
  border-left: 4px solid #52c41a;
  box-shadow: 0 2px 8px rgba(82, 196, 26, 0.08);
}

.msg-row--user .msg-bubble {
  background: #ecf5ff;
  border-color: #b3d8ff;
  color: #303133;
  border-left: none;
  box-shadow: 0 1px 3px rgba(64, 158, 255, 0.12);
}

.msg-bubble--loading {
  color: #909399;
  font-size: 13px;
  border: 1px dashed #dcdfe6;
  background: #fafafa;
  box-shadow: none;
}

.chat-input-wrap {
  position: relative;
  padding-bottom: 44px;
}

.send-btn {
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/assistant/intelligent-hub.vue